import type { Payments } from '@aviata/platform-types';

import { api } from '@/shared/api';
import { sentryModel } from '@/shared/model';

export async function getBillById({ billId }: { billId: string }) {
  try {
    const response = await api.payments.getBill(billId);
    return response.data as Payments.Bill.Entity;
  } catch (error) {
    sentryModel.logBaseError({
      error: error as Error,
      description: 'Payment error: failed to fetch bill',
    });
  }
}

export async function createBill({ orderId }: { orderId: string }) {
  try {
    const response = await api.payments.createBill(orderId);
    return response.data as Payments.Bill.Entity;
  } catch (error) {
    sentryModel.logBaseError({
      error: error as Error,
      description: 'Payment error: could not create bill for order',
    });
  }
}

export async function searchBills({ orderId }: { orderId: string }) {
  try {
    const response = await api.payments.searchBills({ order_id: orderId });
    return response.data as Payments.Bill.Entity[];
  } catch (error) {
    sentryModel.logBaseError({
      error: error as Error,
      description: 'Payment error: could not get search order bills',
    });
  }
}

export interface BillOptions extends Payments.Bill.Options {
  loyalty: {
    cashbacks: {
      usage_allowed: boolean;
      min_amount: number;
      max_amount: number;
      reason: {
        title: string;
        text: string;
      } | null;
    };
  };
}

export async function getBillOptions({ billId }: { billId: string }) {
  try {
    const response = await api.payments.getBillOptions(billId);
    return response.data as BillOptions;
  } catch (cause) {
    sentryModel.logBaseError({
      error: cause as Error,
      description: 'Payment error: failed to fetch bill options',
    });
    throw cause;
  }
}
